// src/screens/Calcleite/Calcleite.js

import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import "./Calcleite.css"; 
import logo from "../../assets/calcleite.png";
import mainImage from "../../assets/maincalcleite.png"; 
import img1 from "../../assets/leite1.jpg";
import img2 from "../../assets/leite2.jpg";
import img3 from "../../assets/leite3.jpg";
import img4 from "../../assets/leite4.jpg";
import img5 from "../../assets/leite5.jpg";

const Calcleite = () => {
  const { user, userData, loading } = useAuth();
  const navigate = useNavigate();

  const handleSubscriptionClick = () => {
    if (loading) return;
    if (!user) {
      navigate("/login");
      return;
    }
    if (userData?.calcleite) {
      navigate("/calcleite/app");
    } else {
      // --- CORREÇÃO AQUI ---
      // Redireciona para a rota de planos dinâmica, passando a chave 'calcleite'
      navigate("/planos/calcleite"); 
    }
  };

  const advantages = [
    { title: "Produção e Produtividade", content: "A produtividade refere-se à quantidade de litros de leite produzidos por vaca, por hectare de pasto ou volumoso...", image: img3, },
    { title: "Custo do Capital e Depreciação", content: "Este conceito mede o retorno financeiro do capital investido em benfeitorias, máquinas, equipamentos, terra e rebanho...", image: img4, },
    { title: "Custos Operacionais", content: "Os custos operacionais incluem todas as despesas recorrentes necessárias para manter a produção de leite...", image: img5, },
    { title: "Receita e Rentabilidade", content: "A receita refere-se ao total de dinheiro gerado pela venda de leite e outros produtos...", image: img1, },
    { title: "Relatório Final", content: "O relatório final fornece uma visão integrada dos resultados calculados ou simulados do negócio...", image: img2, },
  ];

  const plans = [
    { name: "Mensal", price: "R$19,90/mês", features: ["Cálculos ilimitados", "Simulações ilimitadas", "Suporte disponível", "Pagamento mensal"] },
    { name: "Trimestral", price: "R$49,90/trimestre", features: ["Cálculos ilimitados", "Simulações ilimitadas", "Suporte disponível", "Pagamento a cada três meses"] },
    { name: "Anual", price: "R$199,90/ano", features: ["Cálculos ilimitados", "Simulações ilimitadas", "Suporte disponível", "Pagamento anual"] },
  ];

  return (
    <div className="calcleite-container">
      <header className="calcleite-header">
        <div className="logo-container">
          <img src={logo} alt="CalcLeite Logo" className="calcleite-logo" />
        </div>
        <h1>CalcLeite</h1>
        <p className="header-subtitle">
          Com o CalcLeite você obterá independência e autonomia quando se trata
          das economias e finanças do seu negócio, de maneira rápida, simples,
          segura e eficaz.
        </p>
      </header>

      <section className="hero-section static-hero">
        <img src={mainImage} alt="Visão geral do CalcLeite" className="hero-image" />
        <div className="hero-caption">
          <h3>Controle seus Custos, Maximize seus Lucros</h3>
          <p>A ferramenta essencial para a gestão financeira da sua produção de leite.</p>
        </div>
      </section>

      <section className="features-section">
        <div className="feature-card">
          <h3>Controle de Custos</h3>
          <p>O sistema permite o controle detalhado de custos, monitorando despesas com alimentação, cuidados com o gado e operações gerais. Facilita o planejamento financeiro ao auxiliar na criação de orçamentos e planos, otimizando recursos e maximizando os lucros.</p>
        </div>
        <div className="feature-card">
          <h3>Análise de Desempenho</h3>
          <p>A análise de desempenho proporciona uma visão abrangente sobre o estado financeiro do negócio, identificando áreas de lucro e oportunidades de melhoria. Com foco em transparência, o sistema possibilita que todos os envolvidos acessem informações financeiras atualizadas.</p>
        </div>
      </section>

      <section className="plans-section">
        <h2>Confira nossos planos</h2>
        <div className="plans-grid">
          {plans.map((plan, index) => (
            <div className="plan-card" key={index}>
              <div className="plan-header">
                <h3>{plan.name}</h3>
                <p className="plan-price">{plan.price}</p>
              </div>
              <ul className="plan-features">
                {plan.features.map((feature, i) => <li key={i}>{feature}</li>)}
              </ul>
              <button onClick={handleSubscriptionClick} className="plan-button">Assinar</button>
            </div>
          ))}
        </div>
      </section>

      <section className="advantages-section">
        <h2>Vantagens de obter o CalcLeite</h2>
        <div className="advantages-grid">
          {advantages.map((advantage, index) => (
            <div className="advantage-card" key={index}>
              <div className="advantage-image">
                <img src={advantage.image} alt={advantage.title} />
              </div>
              <div className="advantage-content">
                <h3>{advantage.title}</h3>
                <p>{advantage.content}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <div className="cta-container">
        <button onClick={handleSubscriptionClick} className="cta-button" disabled={loading}>
          {loading ? "Carregando..." : "Acessar"}
        </button>
        <Link to="/" className="back-link">Voltar para Home</Link>
      </div>
    </div>
  );
};

export default Calcleite;